import { request } from "./client";

export interface RefundRequest {
  id: string;
  refundNo: string;
  displayRefundNo: string | null;
  orderNo: string;
  displayOrderNo: string | null;
  userId: string;
  requestedAmount: number;
  reason: string;
  status: string;
  adminRemark: string | null;
  createdAt: string;
  orderRefundStatus?: string;
  paymentRefund?: { status: "PENDING" | "PROCESSING" | "SUCCESS" | "FAILED"; refundedAmount: number | null; failureCode: string | null; failureMessage: string | null; successAt: string | null } | null;
}

export interface CustomizationRequest {
  id: string;
  requestNo: string;
  userId: string;
  productId: string | null;
  productName: string | null;
  productNameSnapshot: string | null;
  contactName: string;
  contactPhone: string;
  requirementDescription: string;
  selectedOptions: unknown;
  quantity: number | null;
  referencePriceSnapshot: unknown;
  sourceAction: string;
  status: "NEW" | "CONTACTED" | "DONE";
  adminRemark: string | null;
  contactedAt: string | null;
  completedAt: string | null;
  createdAt: string;
}

export interface CustomizationAttachment {
  id: string;
  originalFilename: string;
  contentType: string;
  fileSize: number;
  status: "UPLOADED" | "BOUND" | "EXPIRED" | "DELETE_FAILED";
  expiresAt: string;
  uploadedAt: string;
  boundAt: string | null;
}

export const listRefunds = async () => (await request<RefundRequest[]>("/admin/refund-requests")).data;

export const updateRefund = async (
  id: string,
  status: "PROCESSING" | "APPROVED" | "REJECTED",
) => (await request<RefundRequest>(`/admin/refund-requests/${id}/status`, {
  method: "PUT",
  body: JSON.stringify({ status }),
})).data;

export const executeRefund = async (id: string) => (
  await request<RefundRequest>(`/admin/refund-requests/${id}/execute`, { method: "POST" })
).data;

export const listCustomizations = async () => (
  await request<CustomizationRequest[]>("/admin/customization-requests")
).data;

export const updateCustomization = async (
  id: string,
  status: "CONTACTED" | "DONE",
  adminRemark?: string | null,
) => (await request<CustomizationRequest>(`/admin/customization-requests/${id}/status`, {
  method: "PUT",
  body: JSON.stringify({ status, ...(adminRemark === undefined ? {} : { adminRemark }) }),
})).data;

export const listCustomizationAttachments = async (requestId: string) => (
  await request<CustomizationAttachment[]>(`/admin/customization-requests/${requestId}/attachments`)
).data;

export const getCustomizationAttachmentUrl = async (requestId: string, attachmentId: string) => (
  await request<{ url: string; expiresInSeconds: number }>(
    `/admin/customization-requests/${requestId}/attachments/${attachmentId}/url`,
  )
).data;
